import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    choseButton: 'Choose Shine ',
    insteadOf: '{taxMention}, instead of',
    perMonth: ' / month {taxMention}',
    pricePerMonth: 'Then {price} / month {taxMention}',
    title: 'Select your pro account',
    trialPeriod: 'month{plural} offered',
    vat: {
      excluded: 'excl. tax',
      included: 'incl. tax',
    },
    yourCurrentOffer: 'Your current offer',
  },
  fr: {
    choseButton: 'Choisir Shine ',
    insteadOf: '{taxMention}, au lieu de',
    perMonth: '{taxMention} / mois',
    pricePerMonth: 'Puis {price} / mois {taxMention}',
    title: 'Choisissez votre compte pro',
    trialPeriod: 'mois offert{plural}',
    vat: {
      excluded: 'HT',
      included: 'TTC',
    },
    yourCurrentOffer: 'Votre offre actuelle',
  },
} as const);
